import React, { useEffect, useState } from 'react'
import {
  GoogleMap,
  Marker,
} from '@react-google-maps/api'
const containerStyle = {
  width: '100%',
  height: '400px'
}

const OMapContainer = props => {
  const { options } = props;
  const { markerPosition, center} = options;
 
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => setIsMounted(true), []);

  return (
    <div className='overflow-hidden rounded-lg my-5 w-full'>
      {/* <LoadScript
        googleMapsApiKey={googleMapsApiKey}
        libraries={libraries}
        width='100%'
      > */}
      <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={7}>
      {
       isMounted && <Marker draggable={false} position={markerPosition} />
      }

        {/* <Autocomplete
          onLoad={autocomplete => {
            setAutocompleteLoaded(true)
            autocompleteRef.current = autocomplete
          }}
          options={{
            // types: ["geocode"],
            componentRestrictions: { country: COUNTRY_RESTRICTIONS },
          }}
          // bounds={AREA_BOUND}
          onPlaceChanged={handlePlaceChanged}
        >
          <input
            type='text'
            placeholder='Search location'
            className='form-control'
            value={address}
            onChange={e => setAddress(e.target.value)}
            style={{
              boxSizing: 'border-box',
              border: '1px solid transparent',
              width: '400px',
              height: '40px',
              padding: '0 12px',
              borderRadius: '3px',
              boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
              fontSize: '14px',
              outline: 'none',
              textOverflow: 'ellipses',
              position: 'absolute',
              left: '50%',
              top: '5px'
              // marginLeft: "-120px",
            }}
          />
        </Autocomplete> */}
      </GoogleMap>
      {/* </LoadScript> */}
    </div>
  )
}

export default OMapContainer
